import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

interface ScheduleNav {
  /** 遷移先の予定ID。Shell がタブを切り替え、Schedule が消化して null に戻す */
  targetEventId: string | null;
  /** 予定タブへ切り替え、その予定がある日を開く */
  goToEvent: (eventId: string) => void;
  /** Schedule 側が読み終わったら呼ぶ */
  consumeTarget: () => void;
}

const ScheduleNavContext = createContext<ScheduleNav | null>(null);

/**
 * 通知(→ NotificationSheet)から予定タブのその日へ飛ぶための橋渡し。
 *
 * このアプリはタブ切り替えを URL ではなく Shell の state で持つ SPA なので、
 * 通知はどの画面からでも押されうる一方、遷移先を決められるのは Shell と
 * Schedule だけ。両者の間を state のバケツリレーなしに繋ぐために持つ
 * (→ MediaTasksProvider と同じ理由)。
 */
export function useScheduleNav(): ScheduleNav {
  const nav = useContext(ScheduleNavContext);
  if (nav === null) throw new Error("ScheduleNavProvider の外では使えません");
  return nav;
}

export function ScheduleNavProvider({ children }: { children: ReactNode }) {
  const [targetEventId, setTargetEventId] = useState<string | null>(null);

  const goToEvent = useCallback((eventId: string) => {
    setTargetEventId(eventId);
  }, []);
  const consumeTarget = useCallback(() => {
    setTargetEventId(null);
  }, []);

  return (
    <ScheduleNavContext.Provider value={{ targetEventId, goToEvent, consumeTarget }}>
      {children}
    </ScheduleNavContext.Provider>
  );
}
